/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';
import type { GetAppointmentResponse } from './GetAppointmentResponse';
import {
    GetAppointmentResponseFromJSON,
    GetAppointmentResponseFromJSONTyped,
    GetAppointmentResponseToJSON,
    GetAppointmentResponseToJSONTyped,
} from './GetAppointmentResponse';

/**
 * 
 * @export
 * @interface PaginatedResultOfGetAppointmentResponse
 */
export interface PaginatedResultOfGetAppointmentResponse {
    /**
     * 
     * @type {Array<GetAppointmentResponse>}
     * @memberof PaginatedResultOfGetAppointmentResponse
     */
    items?: Array<GetAppointmentResponse>;
    /**
     * 
     * @type {any}
     * @memberof PaginatedResultOfGetAppointmentResponse
     */
    lastSelectedId?: any | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetAppointmentResponse
     */
    pageNumber?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetAppointmentResponse
     */
    pageSize?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetAppointmentResponse
     */
    totalCount?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetAppointmentResponse
     */
    hasNextPage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetAppointmentResponse
     */
    hasPreviousPage?: boolean;
}

/**
 * Check if a given object implements the PaginatedResultOfGetAppointmentResponse interface.
 */
export function instanceOfPaginatedResultOfGetAppointmentResponse(value: object): value is PaginatedResultOfGetAppointmentResponse {
    return true;
}

export function PaginatedResultOfGetAppointmentResponseFromJSON(json: any): PaginatedResultOfGetAppointmentResponse {
    return PaginatedResultOfGetAppointmentResponseFromJSONTyped(json, false);
}

export function PaginatedResultOfGetAppointmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedResultOfGetAppointmentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(GetAppointmentResponseFromJSON)),
        'lastSelectedId': json['lastSelectedId'] == null ? undefined : json['lastSelectedId'],
        'pageNumber': json['pageNumber'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageNumber']),
        'pageSize': json['pageSize'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageSize']),
        'totalCount': json['totalCount'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['totalCount']),
        'hasNextPage': json['hasNextPage'] == null ? undefined : json['hasNextPage'],
        'hasPreviousPage': json['hasPreviousPage'] == null ? undefined : json['hasPreviousPage'],
    };
}

export function PaginatedResultOfGetAppointmentResponseToJSON(json: any): PaginatedResultOfGetAppointmentResponse {
    return PaginatedResultOfGetAppointmentResponseToJSONTyped(json, false);
}

export function PaginatedResultOfGetAppointmentResponseToJSONTyped(value?: PaginatedResultOfGetAppointmentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(GetAppointmentResponseToJSON)),
        'lastSelectedId': value['lastSelectedId'],
        'pageNumber': ApiUserTasksGetPageParameterToJSON(value['pageNumber']),
        'pageSize': ApiUserTasksGetPageParameterToJSON(value['pageSize']),
        'totalCount': ApiUserTasksGetPageParameterToJSON(value['totalCount']),
        'hasNextPage': value['hasNextPage'],
        'hasPreviousPage': value['hasPreviousPage'],
    };
}

